import { makeGetRequest } from 'lib/axios';

const verifyInvite = async (token: string): Promise<any> => {
  const url = `/auth/verify-invite/${token}`;
  const response = await makeGetRequest(url);
  return response.data.payload;
};

export default verifyInvite;
